import React from 'react';
import ApexChart from 'react-apexcharts';

const CHART_SIZE = { width: '125', height: '125' };

export default function Chart(props) {

    const {type="radialBar", series=[0], barColor='#111', color='#888', subtitleText=""} = props

    const options = {
        series: [67],
        colors: [barColor],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 15,
              size: "50%"
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false,
                color,
                fontSize: "16px"
              },
              value: {
                offsetY: 7,
                show: true,
                color: "#000",
                fontSize: "18px"
              }
            },
          }
        },
        stroke: {
          lineCap: "round"
        },
        subtitle: {
            text: subtitleText,
            offsetY: 165,
            offsetX: 85,
            style: {
              fontSize:  '1px',
              fontWeight:  'normal',
              color:  '#9699a2'
            },
        }
      };

    return(
        <ApexChart 
            type={type} 
            series={series} 
            options={options} 
            {...CHART_SIZE} 
  		  />

    )
}